const Moscow = {
  DMO: 'MOW',
  SVO: 'MOW',
  VKO: 'MOW',
  ZIA: 'MOW',
};

const Istanbul = {
  SAW: 'IST',
  IST: 'IST',
  ISL: 'IST',
};

export const citiesByAirports: Record<string, string> = {
  ...Moscow,
  ...Istanbul,
};
